import { RewardItem, FlexWrapper } from '@intigral/shared';
import { IQuestsProps } from '../../types/iQuest';

const Quests = ({ questProps }) => {
    const {
        quests = [],
        isLoading = false,
        buildRewardProps,
        shouldRenderQuest = () => true,
    }: IQuestsProps = questProps;

    return (
        <FlexWrapper flexDirection="column" gap={{ default: '1x', md: '2x' }}>
            {isLoading && <RewardItem isLoading heading=" " />}

            {!isLoading &&
                quests.map((quest) => {
                    if (!shouldRenderQuest(quest)) return null;

                    const props = buildRewardProps(quest);
                    if (!props) return null;

                    return <RewardItem key={quest.id} {...props} />;
                })}
        </FlexWrapper>
    );
};

export default Quests;
